import { Icon } from "simplydo/react/ui/icon";
import { Label } from "simplydo/react/ui/label";
import type { UiColor } from "simplydo/react/ui/utils/colors";

import { getRoleIcon } from "./roleIcons";

type RoleLabelProps = {
  role: { name?: string; icon?: { name?: string; colour?: string } };
};

export const RoleLabel = ({ role }: RoleLabelProps) => {
  const icon = getRoleIcon(role.icon?.name);
  return (
    <Label
      circular
      size="small"
      color={(role.icon?.colour as UiColor) || undefined}
    >
      {icon ? <Icon icon={icon} /> : null}
      {role.name}
    </Label>
  );
};
